'use client';
import { memo } from 'react';
import type { ReactElement } from 'react';
import { motion } from 'framer-motion';
import { Cherocarouselcontrols } from '../Cherocarouselcontrols';
import { HERO_ANIMATION } from './Chero.constants';
import { getMountedTeamControlHandlers } from './Chero.control-selectors';
import { getHeroControlsAnimation, getHeroControlsWrapperStyle, } from './Chero.styles';
interface CheroControlsProps {
    isControlsVisible: boolean;
    isMobile: boolean;
    isTeamsMounted: boolean;
    onAllTeams?: () => void;
    onBuildYourOwn?: () => void;
    onDeployTeam: () => void;
    onInspectTeam: () => void;
    onNext: () => void;
    onPrevious: () => void;
}
export const CheroControls = memo(function CheroControls({ isControlsVisible, isMobile, isTeamsMounted, onAllTeams, onBuildYourOwn, onDeployTeam, onInspectTeam, onNext, onPrevious, }: CheroControlsProps): ReactElement {
    const mountedTeamControlHandlers = getMountedTeamControlHandlers({
        isTeamsMounted,
        onDeployTeam,
        onInspectTeam,
        onNext,
        onPrevious,
    });
    return (
      <motion.div data-el="Chero/Controls/Root" initial={false} animate={getHeroControlsAnimation({ isControlsVisible })} transition={{
            duration: 0.35,
            ease: HERO_ANIMATION.ease,
        }} style={getHeroControlsWrapperStyle({ isMobile, isControlsVisible })}>
        <Cherocarouselcontrols onPrevious={mountedTeamControlHandlers.onPrevious} onNext={mountedTeamControlHandlers.onNext} onDeployTeam={mountedTeamControlHandlers.onDeployTeam} onInspectTeam={mountedTeamControlHandlers.onInspectTeam} onBuildYourOwn={onBuildYourOwn} onAllTeams={onAllTeams} entranceDelay={HERO_ANIMATION.controls.delayAfterReady} entranceReady={isControlsVisible}/>
      </motion.div>
    );
});
